<script lang="ts" setup>
import { storeToRefs } from 'pinia'

import { useGiDataUploadCollectionStore } from '@/stores/giDataUploadCollection'

const giDataUploadCollectionStore = useGiDataUploadCollectionStore()
const { useEPSG, zoneNumber, hemisphere } = storeToRefs(giDataUploadCollectionStore)
</script>

<template>
  <v-col cols="2"> <v-checkbox v-model="useEPSG" hide-details label="use EPSG"></v-checkbox></v-col>
  <v-col cols="4">
    <v-combobox
      v-if="useEPSG"
      v-model="zoneNumber"
      :items="Array.from({ length: 60 }, (_, i) => i + 1)"
      label="UTM Zone"
      :rules="[
        (v) => !!v || 'Zone is required',
        (v) => (v >= 1 && v <= 60) || 'Zone must be between 1 and 60'
      ]"
      type="number"
      validate-on="input lazy"
      outlined
      dense
      :max="60"
      :min="1"
      hide-details
      color="primary"
    ></v-combobox>
  </v-col>
  <v-col cols="3">
    <v-select
      v-if="useEPSG"
      v-model="hemisphere"
      :items="['N', 'S']"
      label="Hemisphere"
      outlined
      dense
      color="primary"
      hide-details
    ></v-select>
  </v-col>
</template>
